import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import ghost from "../../assets/images/ghost.png";

const ErrorBoundaryFallback = props => {
  const { error, componentStack } = props;
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="80vh"
      pt={5}
    >
      <Typography variant="h3">Oops, Something went wrong.</Typography>

      <Box mt={3.5} mb={5}>
        <img src={ghost} height={200} alt="Ghost" />

        {/*<Typography variant="h2">¯\_(ツ)_/¯</Typography>*/}
      </Box>

      <details style={{ whiteSpace: "pre-wrap" }}>
        {error && error.toString()}
        <br />
        {componentStack}
      </details>
    </Box>
  );
};

export default ErrorBoundaryFallback;
